import React, { Component } from 'react'

import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form';

import { GetCommunityMealTypes } from '../../actions/communityActions';
import { GetDiningTags } from '../../actions/diningActions';



import { Button, Checkbox, Chip, Grid, IconButton, Popover, Slide } from '@material-ui/core';
import { renderJustDatePicker } from '../../utils/engageComponents';
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';
import moment from 'moment';

const options=['7 Days', '2 Weeks', '30 Days'];


class DiningsFilters extends Component {
    constructor(props){
        super(props);
        this.state={
            dateChanged:(this.props.filters && this.props.filters.dateChanged)? this.props.filters.dateChanged : false,
            dateOptionSelected:(this.props.filters && this.props.filters.dateOptionSelected)? this.props.filters.dateOptionSelected : null,
            startDate: (this.props.filters && this.props.filters.startDate)? this.props.filters.startDate : new Date(),
            endDate:  (this.props.filters && this.props.filters.endDate)? this.props.filters.endDate : new Date(),
            mealsSelected:(this.props.filters && this.props.filters.mealsSelected)? this.props.filters.mealsSelected: [],
            tagsSelected:(this.props.filters && this.props.filters.tagsSelected)? this.props.filters.tagsSelected : []
           
        }    

    };

    componentDidMount(){

        const id = localStorage.getItem('communityId')

        this.props.GetCommunityMealTypes(id)

        this.getTags();
    }

    getTags = async()=>{
        const id = localStorage.getItem('communityId')

        const newTags = await this.props.GetDiningTags(id, this.state.dateChanged ,this.state.dateOptionSelected, this.state.startDate, this.state.endDate)
        
        const existTags = this.state.tagsSelected;

        if(existTags.length>0){ //If we had tags already selected is possible that those tags aren't include in the new date range selected
            //remove the tags that aren't in our current tags arr 
            const arrFiltered = existTags.filter(t=>newTags.find(i=>i===t))

            this.setState({tagsSelected:arrFiltered})

        }

    }

    handleChangeDate(date, type) {

        const upd={
            dateOptionSelected:null,
            dateChanged:true,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
        }

        if(type==='start'){

            if(date>this.state.endDate){
                const add1Day=moment(date).add(1,'day')

                upd.startDate = date;
                upd.endDate = add1Day

            }else{
                upd.startDate = date;

            }

        }else if(type==='end'){
        
            if(date<this.state.startDate){
                const remove1Day=moment(date).subtract(1,'day')                
                upd.endDate = date;
                upd.startDate = remove1Day

            }else{
                upd.endDate = date;

            }
        }

        this.setState(upd, ()=>this.getTags())

    }

    handleSelectMealTime = (meal) =>{

        const arr = this.state.mealsSelected;

        const item = arr.find(item =>item===meal);

        if (!item) {
            arr.push(meal)
        }
        else {
            const indexToDelete = arr.indexOf(meal);
            arr.splice(indexToDelete, 1);

        }

        this.setState({ mealsSelected: arr });

    }


    handleSelectOption=(e,op)=>{
        this.setState({
            dateOptionSelected:op,
            dateChanged:false,
            startDate: new Date(),
            endDate: new Date()
        }, ()=>this.getTags())
    }

    handleSelectTag=(tag)=>{
        const arr = this.state.tagsSelected;

        const item = arr.find(item =>item===tag);

        if (!item) {
            arr.push(tag)
        }
        else {
            const indexToDelete = arr.indexOf(tag);
            arr.splice(indexToDelete, 1);

        }

        this.setState({ tagsSelected: arr });
    }

    resetfilter=()=>{
        this.setState({
            dateChanged:false,
            dateOptionSelected: null,
            startDate: new Date(),
            endDate: new Date(),
            mealsSelected: [],
            tagsSelected: []
        },()=>this.getTags());

        this.props.resetFilters();
    }

    handleApplyFilters = ()=>{

        const filtersToSend = {...this.state}
        this.props.applyFilters(filtersToSend)
        this.props.onClose();
    }


    render() {
        return (
            <>
               <Popover
                    id="DiningsFilterPopOver"
                    open={true}
                    onClose={this.props.onClose}
                    anchorEl={this.props.anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                        
                    PaperProps={{
                        className:'activity_filters_popover',
                    }}
                    elevation={0}
                >
                    <Slide in={true} direction='left' timeout={600} mountOnEnter unmountOnExit>
                        <Grid container xs={12} className='activity_filters_slide'>
                            <form style={{width:'100%'}}>

                                {/* Title and close icon */}
                                <Grid item container xs={12} justifyContent='space-between' alignItems='center'>
                                    <Grid item className='filters_title'>Filters</Grid>

                                    <IconButton onClick={()=>this.props.onClose()}>
                                        <img
                                            src='https://engage360.s3.amazonaws.com/Icons/Categories/times-circle.svg'
                                            alt='close_icon'
                                            width='32px'
                                            height='32px'
                                            style={{fontWeight:'bold'}}
                                        />
                                    </IconButton>
                                </Grid>

                                {/* Apply filters buttons */}
                                <Grid item container xs={12}>
                                    <Button className="filters_btn" onClick={this.handleApplyFilters}>Apply Current Filters</Button>
                                    <Button className='filters_clear_btn' onClick={this.resetfilter}>Clear All</Button>
                                </Grid>

                                {/* Date ranges */}
                                <Grid item container xs={12} justifyContent='space-between'>
                                    <Grid item xs={12} className='filters_subtitles sectionMargin'>Date Range</Grid>

                                    {/* Date range */}
                                    <Grid item className={!this.state.dateChanged? 'date_range_box' :'date_range_box_selected'}>                               
                                        <Field
                                            name="startDate"
                                            labelDate="From"
                                            selectedDate={this.state.startDate} //most be an date object is use in both date and time
                                            onDateChange={(date) => this.handleChangeDate(date, 'start')}
                                            maxLength={20}
                                            component={renderJustDatePicker}
                                            idToSet='filters_date'
                                            id='dinings_filters_date'
                                            active={!this.state.dateOptionSelected}
                                        />
                                    </Grid>

                                    <Grid item className={!this.state.dateChanged? 'date_range_box' :'date_range_box_selected'}>
                                        <Field
                                            name="endDate"
                                            labelDate="To"
                                            selectedDate={this.state.endDate} //most be an date object is use in both date and time
                                            onDateChange={(date) => this.handleChangeDate(date, 'end')}
                                            maxLength={20}
                                            component={renderJustDatePicker}
                                            idToSet='filters_end_date'
                                            id='activity_filters_end_date'
                                            active={!this.state.dateOptionSelected}

                                        />
                                    </Grid>


                                    {/* Dates Fixed Options */}
                                    <Grid item xs={12} className='ligth_txt sectionMargin'>Or the next</Grid>

                                    {
                                        options.map((op, index)=>{
                                            return(
                                                <Grid item key={`option_${index}`} 
                                                    onClick={(e)=>this.handleSelectOption(e,op)}
                                                    className={(this.state.dateOptionSelected===op)? 'ligth_txt option_box_selected' : 'ligth_txt option_box' }
                                                    style={{
                                                        color:(this.state.dateOptionSelected)?'#009EDD':'#757575', 
                                                        border:(this.state.dateOptionSelected)?'2px solid #009EDD':'2px solid #868686'
                                                    }} 
                                                >
                                                    {op}
                                                </Grid>
                                            )
                                        })
                                    }



                                </Grid>

                                {/* Meals times */}
                                <Grid item container xs={12} className='sectionMargin' justifyContent='flex-start'>
                                    <Grid item xs={12} className='filters_subtitles'>Meal time</Grid>

                                    {
                                        this.props.mealsTimes && this.props.mealsTimes.map((meal, index)=>{
                                            const isSelected = this.state.mealsSelected.find(i=>i===meal.mealType)

                                            return(
                                                <Grid item container key={meal._id} id={`meal_${meal._id}`} className="category_box_wrapper"
                                                    style={{marginRight:(index+1!==this.props.mealsTimes.length)&&'2%'}}
                                                >
                                                <Grid item container justifyContent='center' 
                                                    className={isSelected?'filters_category_box_selected':'filters_category_box'}
                                                    onClick={()=>this.handleSelectMealTime(meal.mealType)}
                                                >
                                                    <Grid item container xs={12} justifyContent='flex-end'>
                                                        <Checkbox
                                                            checked={isSelected?true:false}
                                                            onChange={(e) => this.handleSelectMealTime(meal.mealType) }
                                                            onClick={(e) => e.stopPropagation()}
                                                            icon={<CheckBoxOutlineBlank/>}
                                                            checkedIcon={<CheckBox style={{color:'white'}}/>}
                                                            id={`meal_checkbox_${meal._id}`}
                                                        />
                                                        </Grid>
                                                        <Grid item container xs={12} justifyContent='center'>
                                                            <img
                                                                src={meal.mealIconUrl}
                                                                alt='meal_icon'
                                                                width='32px'
                                                                height='32px'
                                                            />
                                                        </Grid>
                                            
                                                    <Grid className="ligth_txt" style={{textAlign:'center'}}>{meal.mealName}</Grid>
                                                </Grid>
                                                </Grid>
                                            )
                                        })
                                    }

                                </Grid>

                                {/* Tags */}
                                <Grid item container xs={12} className='sectionMargin' >
                                    <Grid item xs={12} className='filters_subtitles'>Tags</Grid>

                                    {
                                        this.props.tags && this.props.tags.map((t, index)=>{
                                            const isSelected=this.state.tagsSelected.find(i=>i===t);

                                            return(
                                                <Chip
                                                    className={isSelected?'tags_styles_selected':"tags_styles"}
                                                    key={'chip' + index}
                                                    size='large'
                                                    label={t}
                                                    onClick={()=>this.handleSelectTag(t)}
                                                />
                                            )
                                        })
                                    }

                                </Grid>

                                {/* Apply filters button */}
                                <Grid item container xs={12} className='sectionMargin'>
                                    <Button className="filters_btn" onClick={this.handleApplyFilters}>Apply Current Filters</Button>
                                </Grid>

                            </form>
                        </Grid>
                    </Slide>
                </Popover>
            </>
        )
    }
}

function mapStateToProps(state){
    const tags = (state.diningReducer && state.diningReducer.tags) ? state.diningReducer.tags : [];
    let mealsTimes = (state.communityReducer && state.communityReducer.mealsData) ? state.communityReducer.mealsData : [];

    return{
        tags,
        mealsTimes
    };
}


export default connect(mapStateToProps,{GetCommunityMealTypes, GetDiningTags})(reduxForm({
    form: 'DiningFilters',
})(DiningsFilters));

